import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class Currency {
  public static readonly PRIMARY_CURRENCY = "EUR";
  public static readonly SECONDARY_CURRENCY = "BGN";

  /**
   * Converts an amount between currencies and applies optional formatting.
   */
  public convertAmount(
    amount: number,
    currency: string = Currency.PRIMARY_CURRENCY,
    targetCurrency:string = Currency.SECONDARY_CURRENCY,
    addFormatting: boolean = true,
    addCurrencySymbol: boolean = true
  ): string | number {
    const rate = this.getConversionRate(currency, targetCurrency);
    let convertedAmount: number = Math.round(amount * rate * 100) / 100;

    let result: string | number = convertedAmount;

    if (addFormatting) {
      result = convertedAmount.toFixed(2);
    }

    if (addCurrencySymbol) {
      result = `${result}${this.getSymbol(targetCurrency)}`;
    }

    return result;
  }

  public getConversionRate(currency: string, targetCurrency: string): number {
    let currencyRate = 1;

    if (currency !== targetCurrency) {
      currencyRate = targetCurrency === "BGN" ? 1.95583 : 0.511292;
    }

    return currencyRate;
  }

  public getSymbol(currency: string): string {
    return currency === "BGN" ? "лв." : "€";
  }
}
